import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import BestOfBackgroundImage from './BestOfBackgroundImage'
import BestOfSquareLogo from './BestOfSquareLogo'

const Background = styled(BestOfBackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`

const Content = styled(Group)`
  transform: translateZ(0);
`

const Banner = styled.div`
  padding: ${rem(12)};
  position: relative;
`

function BestOfOfferPageBanner() {
  return <Banner>
    <Background overlayStyle="default"/>
    <Content
      direction="horizontal"
      gap={12}
      verticalAlign="center"
      horizontalAlign="center"
  >
      <BestOfSquareLogo height={40} />
      <BodyText variant="medium" colour="neutral-eight" weight="bold">
        This offer is <u>back</u> for a limited time only
      </BodyText>
    </Content>
  </Banner>
}

export default BestOfOfferPageBanner
